<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">Administración de Kardex</h2>
    <div v-if="houses.length" class="grid grid-cols-12 gap-6 mt-5 max-w-xl">
      <div class="col-span-12 md:col-span-9">
        <label class="form-label">Seleccione la residencia</label>
        <select
          v-model="houseSelected"
          data-placeholder="Selecciona la residencia"
          class="w-full form-select mt-1"
          @change="houseChanged"
        >
          <option v-for="item in houses" :key="item.id" :value="item">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>
    <div
      v-if="houseSelected && residents.length"
      class="grid grid-cols-12 gap-6 mt-5 max-w-xl"
    >
      <div class="col-span-12 md:col-span-9">
        <label class="form-label">Seleccione el residente</label>
        <select
          v-model="residentSelected"
          data-placeholder="Selecciona el residente"
          class="w-full form-select mt-1"
          @change="residentChanged"
        >
          <option v-for="item in residents" :key="item.id" :value="item">
            {{ item.full_name }}
          </option>
        </select>
      </div>
    </div>
    <h1
      v-else-if="houseSelected"
      class="my-10 text-center text-2xl font-medium"
    >
      La casa seleccionada no tiene residentes
    </h1>
    <div class="grid grid-cols-12 gap-6 mt-5" v-if="residentSelected">
      <div
        class="
          intro-y
          col-span-12
          flex flex-wrap
          sm:flex-nowrap
          items-center
          mt-2
          ml-auto
        "
      >
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="relative text-gray-700 dark:text-gray-300">
            <input
              v-model="search"
              type="text"
              class="form-control w-72 box pr-10 placeholder-theme-13"
              placeholder="Buscar"
              @change="setFirstPage"
            />
            <SearchIcon
              class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0"
            />
          </div>
        </div>
      </div>
      <!-- BEGIN: Data List -->
      <template v-if="medicines">
        <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
          <table
            class="table table-report -mt-2"
            aria-describedby="administrators table"
          >
            <thead>
              <tr>
                <th id="nombre" class="text-center whitespace-nowrap">
                  Nombre
                </th>
                <th id="id_med" class="text-center whitespace-nowrap">
                  ID-MED
                </th>
                <th id="KEYNAME" class="text-center whitespace-nowrap">
                  Key Name
                </th>
                <th id="actionsH" class="text-center whitespace-nowrap">
                  Seleccionar
                </th>
              </tr>
            </thead>
            <tbody>
              <tr :key="row.id" v-for="row in elements">
                <td class="text-center w-10 font-medium">
                  {{ row.name }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.id_med }}
                </td>
                <td class="text-center w-10 font-medium">
                  {{ row.key_name }}
                </td>
                <td class="table-report__action w-56">
                  <div class="flex justify-center items-center">
                    <a
                      class="flex items-center mr-3 text-green-600"
                      href="javascript:;"
                      @click="showModalCreate(row)"
                    >
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      Seleccionar
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Pagination -->
        <div
          class="
            intro-y
            col-span-12
            flex flex-wrap
            sm:flex-row sm:flex-nowrap
            items-center
            pb-10
          "
          v-if="pages > 1"
        >
          <ul class="pagination ml-auto" style="margin-right: revert;">
            <li @click="setFirstPage" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronsLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="changePageNegative" v-if="page !== 1">
              <a class="pagination__link" href="javascript:;">
                <ChevronLeftIcon class="w-4 h-4" />
              </a>
            </li>
            <li
              :key="element"
              v-for="element in [...Array(maxShowButtonPages).keys()].map(
                (dataElement, index) =>
                  activeGroup * maxShowButtonPages -
                  (maxShowButtonPages - index) +
                  1
              )"
            >
              <template v-if="element <= pages">
                <a
                  class="pagination__link"
                  href="javascript:;"
                  @click="page = element"
                  :class="{ 'pagination__link--active': element === page }"
                  >{{ element }}
                </a>
              </template>
            </li>
            <li v-if="page !== pages" @click="changePagePositive">
              <a class="pagination__link" href="javascript:;">
                <ChevronRightIcon class="w-4 h-4" />
              </a>
            </li>
            <li @click="setlastPage" v-if="page !== pages">
              <a class="pagination__link" href="javascript:;">
                <ChevronsRightIcon class="w-4 h-4" />
              </a>
            </li>
          </ul>
        </div>
        <!-- END: Pagination -->

        <div class="col-span-12" v-if="kardexData.length">
          <hr
            class="mx-auto"
            style="
                border: 2px solid #38a1f7;
              "
          />
          <h2 class="text-2xl font-medium truncate mt-5 mb-2">KARDEX</h2>
          <h3 class="text-xl font-bold my-2" style="color: #38a1f7;">
            {{ kardexData.length }}
            {{ kardexData.length === 1 ? 'prescripción' : 'prescripciones' }}
          </h3>
          <div v-for="kardex in kardexData" :key="kardex.id">
            <hr
              class="mx-auto"
              style="
                      border: 1px solid #acacac;
                      width: 98%;
                    "
            />
            <div style="margin: 1rem; display: flex">
              <div style="display: flex; flex-direction: column; width: 50%">
                <span class="font-bold">{{ kardex.medicine.key_name }}</span>
                <span class="text-sm font-medium"> {{ kardex.dose }}</span>
              </div>
              <div style="display: flex; flex-direction: column; width: 50%">
                <span v-if="kardex.type === 'PRN'">
                  Solo por razones necesarias.
                </span>
                <span v-if="kardex.type === 'CUSTOM'">
                  {{ kardex.custom_dose }}
                </span>
                <span v-if="kardex.type === 'DAILY'">
                  <template v-if="kardex.morning_dose">
                    {{
                      kardex.morning_dose === 'PRN'
                        ? 'Tomar solo por razones necesarias en la mañana'
                        : 'Tomar ' +
                          kardex.morning_dose.toString() +
                          ' en la mañana'
                    }}{{
                      kardex.morning_dose_hour
                        ? ' (a las ' +
                          momentClass(
                            kardex.morning_dose_hour,
                            'HH:mm:ss'
                          ).format('HH:mm') +
                          ').'
                        : '.'
                    }}
                  </template>
                  <template v-if="kardex.afternoon_dose">
                    {{
                      kardex.afternoon_dose === 'PRN'
                        ? 'Por la tarde tomar solo por razones necesarias'
                        : 'Por la tarde tomar ' +
                          kardex.afternoon_dose.toString()
                    }}{{
                      kardex.afternoon_dose_hour
                        ? ' (a las ' +
                          momentClass(
                            kardex.afternoon_dose_hour,
                            'HH:mm:ss'
                          ).format('HH:mm') +
                          ').'
                        : '.'
                    }}
                  </template>
                  <template v-if="kardex.night_dose">
                    {{
                      kardex.night_dose === 'PRN'
                        ? 'En la noche tomar solo por razones necesarias'
                        : 'En la noche tomar ' + kardex.night_dose.toString()
                    }}{{
                      kardex.night_dose_hour
                        ? ' (a las ' +
                          momentClass(
                            kardex.night_dose_hour,
                            'HH:mm:ss'
                          ).format('HH:mm') +
                          ').'
                        : '.'
                    }}
                  </template>
                </span>
              </div>
            </div>
            <div class="m-4 flex flex-col">
              <button
                type="button"
                class="btn btn-danger px-5 w-32"
                @click="deleteItemKardex(kardex.id)"
              >
                Eliminar
              </button>
            </div>
          </div>
          <hr
            class="mx-auto"
            style="
                border: 2px solid #38a1f7;
              "
          />
        </div>
      </template>
    </div>

    <!-- BEGIN: MODALS -->

    <!-- BEGIN: Modal Add Row -->
    <div ref="createRow" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <form @submit.prevent="createAction">
          <div class="modal-content">
            <!-- BEGIN: Modal Header -->
            <div class="modal-header">
              <h2 class="font-medium text-base mr-auto">
                Información Adicional del Kardex
              </h2>
            </div>
            <!-- END: Modal Header -->
            <!-- BEGIN: Modal Body -->
            <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
              <div class="col-span-12">
                <label class="form-label">Tipo</label>
                <select
                  v-model="createForm.type"
                  data-placeholder="Selecciona el tipo"
                  class="w-full form-select mt-1"
                  @change="changeKardexType"
                  required
                >
                  <option :value="'DAILY'">DIARIO</option>
                  <option :value="'PRN'">PRN</option>
                  <option :value="'CUSTOM'">CUSTOM</option>
                </select>
              </div>
              <div class="col-span-12 mt-2">
                <label class="form-label">Dosis</label>
                <input
                  v-model="createForm.dose"
                  type="text"
                  class="form-control"
                  placeholder="Dosis"
                  required
                />
              </div>
              <template v-if="createForm.type === 'DAILY'">
                <div class="col-span-12 mt-4">
                  <label class="form-label">Dosis Matutina</label>
                  <input
                    v-model="createForm.morning_dose"
                    :disabled="createForm.morning_dose_prn"
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="Dosis Matutina"
                  />
                </div>
                <div class="col-span-12 mt-2">
                  <div class="form-check">
                    <input
                      id="checkbox-switch-morning-dose"
                      class="form-check-input"
                      type="checkbox"
                      @change="
                        createForm.morning_dose = createForm.morning_dose_prn
                          ? 'PRN'
                          : ''
                      "
                      v-model="createForm.morning_dose_prn"
                    />
                    <label
                      class="form-check-label"
                      for="checkbox-switch-morning-dose"
                      >Marcar como PRN
                    </label>
                  </div>
                </div>
                <div class="col-span-12 mt-2">
                  <label class="form-label"
                    >Hora de la dosis matutina (Opcional)</label
                  >
                  <input
                    v-model="createForm.morning_dose_hour"
                    type="time"
                    class="form-control"
                    @keydown="$event.preventDefault()"
                  />
                </div>
                <div class="col-span-12 mt-4">
                  <label class="form-label">Dosis Vespertina</label>
                  <input
                    v-model="createForm.afternoon_dose"
                    :disabled="createForm.afternoon_dose_prn"
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="Dosis Vespertina"
                  />
                </div>
                <div class="col-span-12 mt-2">
                  <div class="form-check">
                    <input
                      id="checkbox-switch-afternoon-dose"
                      class="form-check-input"
                      type="checkbox"
                      @change="
                        createForm.afternoon_dose = createForm.afternoon_dose_prn
                          ? 'PRN'
                          : ''
                      "
                      v-model="createForm.afternoon_dose_prn"
                    />
                    <label
                      class="form-check-label"
                      for="checkbox-switch-afternoon-dose"
                      >Marcar como PRN
                    </label>
                  </div>
                </div>
                <div class="col-span-12 mt-2">
                  <label class="form-label"
                    >Hora de la dosis vespertina (Opcional)</label
                  >
                  <input
                    v-model="createForm.afternoon_dose_hour"
                    type="time"
                    class="form-control"
                    @keydown="$event.preventDefault()"
                  />
                </div>
                <div class="col-span-12 mt-4">
                  <label class="form-label">Dosis Nocturna</label>
                  <input
                    v-model="createForm.night_dose"
                    :disabled="createForm.night_dose_prn"
                    type="number"
                    min="1"
                    class="form-control"
                    placeholder="Dosis Nocturna"
                  />
                </div>
                <div class="col-span-12 mt-2">
                  <div class="form-check">
                    <input
                      id="checkbox-switch-night-dose"
                      class="form-check-input"
                      type="checkbox"
                      @change="
                        createForm.night_dose = createForm.night_dose_prn
                          ? 'PRN'
                          : ''
                      "
                      v-model="createForm.night_dose_prn"
                    />
                    <label
                      class="form-check-label"
                      for="checkbox-switch-night-dose"
                      >Marcar como PRN
                    </label>
                  </div>
                </div>
                <div class="col-span-12 mt-2">
                  <label class="form-label"
                    >Hora de la dosis nocturna (Opcional)</label
                  >
                  <input
                    v-model="createForm.night_dose_hour"
                    type="time"
                    class="form-control"
                    @keydown="$event.preventDefault()"
                  />
                </div>
              </template>
              <template v-if="createForm.type === 'CUSTOM'">
                <div class="col-span-12 mt-4">
                  <label class="form-label">Dosis personalizada</label>
                  <textarea
                    class="resize-none border rounded-md form-control h-24"
                    v-model="createForm.custom_dose"
                  >
                  </textarea>
                </div>
              </template>
            </div>
            <!-- END: Modal Body -->
            <!-- BEGIN: Modal Footer -->
            <div class="modal-footer flex flex-row justify-evenly">
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-outline-secondary px-5"
              >
                Cancelar
              </button>
              <button
                :disabled="!!!createForm.type || !!!createForm.dose"
                type="submit"
                class="btn btn-primary px-2"
              >
                Guardar cambios
              </button>
            </div>
            <!-- END: Modal Footer -->
          </div>
        </form>
      </div>
    </div>
    <!-- END: Modal Add Row -->

    <!-- END: MODALS -->
  </div>
</template>

<script>
import { cleanSession, getFirstErrorMessage } from '../../../utils/tools'
import moment from 'moment-timezone'

export default {
  data() {
    return {
      moment: moment,
      momentClass: moment,
      houses: [],
      houseSelected: undefined,
      residents: [],
      residentSelected: undefined,
      kardexData: [],
      medicines: undefined,
      rowSelected: undefined,
      search: '',
      elementsByPage: 3,
      maxShowButtonPages: 3,
      page: 1,
      activeGroup: 1,
      createForm: {
        resident_id: undefined,
        medicine_id: undefined,
        type: undefined,
        dose: undefined
      }
    }
  },
  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getInitialData()
    await this.getMedicinesData()
    this.$store.commit('main/setShowSpinner', false)
    window.scrollTo(0, 0)
  },
  methods: {
    async getInitialData() {
      try {
        const response = await this.axios.get('/houses', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.houses = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async getMedicinesData() {
      try {
        const response = await this.axios.get('/medicines', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.medicines = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    async houseChanged() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get('/residents-by-house', {
          params: { houseId: this.houseSelected.id },
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.residents = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async residentChanged() {
      this.$store.commit('main/setShowSpinner', true)
      try {
        const response = await this.axios.get(
          `/kardex-by-resident/${this.residentSelected.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        this.kardexData = response.data || []
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    changePagePositive() {
      const page = this.page + 1
      if (page > this.activeGroup * this.maxShowButtonPages) {
        this.activeGroup++
      }
      this.page++
    },
    changePageNegative() {
      const page = this.page - 1
      if (page <= (this.activeGroup - 1) * this.maxShowButtonPages) {
        this.activeGroup = this.activeGroup - 1 === 0 ? 1 : this.activeGroup - 1
      }
      this.page--
    },
    setFirstPage() {
      this.page = 1
      this.activeGroup = 1
    },
    setlastPage() {
      this.page = this.pages
      this.activeGroup = this.totalGroups
    },
    showModalCreate(row) {
      this.createForm = {
        resident_id: this.residentSelected.id,
        medicine_id: row.id,
        type: undefined,
        dose: undefined
      }
      const modal = this.$refs.createRow
      cash(modal).modal('show')
    },
    changeKardexType() {
      this.createForm = {
        resident_id: this.createForm.resident_id,
        medicine_id: this.createForm.medicine_id,
        type: this.createForm.type,
        dose: this.createForm.dose
      }
    },
    async createAction() {
      this.$store.commit('main/setShowSpinner', true)
      const modal = this.$refs.createRow
      cash(modal).modal('hide')
      try {
        await this.axios.post(
          '/create-kardex',
          {
            ...this.createForm
          },
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.auth.token}`
            }
          }
        )
        await this.residentChanged()
        this.$toast.success('El registro se ha creado con exito', {
          position: 'top'
        })
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    },
    async deleteItemKardex(kardexId) {
      this.$store.commit('main/setShowSpinner', true)
      try {
        await this.axios.delete(`/delete-kardex/${kardexId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        await this.residentChanged()
        this.$toast.success(
          'El registro ha sido eliminado satisfactoriamente',
          {
            position: 'top'
          }
        )
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      } finally {
        this.$store.commit('main/setShowSpinner', false)
        window.scrollTo(0, 0)
      }
    }
  },
  computed: {
    filteredElements() {
      if (this.medicines) {
        let elements = this.medicines
        if (this.search && this.search.length) {
          elements = elements.filter(
            row =>
              row.name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.key_name
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.provider
                .toUpperCase()
                .includes(this.search.trim().toUpperCase()) ||
              row.price.toString().includes(this.search.trim()) ||
              row.sale_price.toString().includes(this.search.trim())
          )
        }
        return elements
      }
      return []
    },
    elements: function() {
      if (this.filteredElements) {
        const takeElements =
          this.elementsByPage * this.page - this.filteredElements.length < 0
            ? this.elementsByPage * this.page
            : this.filteredElements.length
        return this.filteredElements.slice(
          this.elementsByPage * this.page - this.elementsByPage,
          takeElements
        )
      }
      return []
    },
    pages: function() {
      return this.filteredElements
        ? Math.ceil(this.filteredElements.length / this.elementsByPage)
        : 1
    },
    totalGroups: function() {
      return Math.ceil(this.pages / this.maxShowButtonPages)
    }
  }
}
</script>
